var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStopExportNode(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 16C10 13.5002 10 12.2503 10.6366 11.374C10.8422 11.0911 11.0911 10.8422 11.374 10.6366C12.2503 10 13.5002 10 16 10C18.4998 10 19.7497 10 20.626 10.6366C20.9089 10.8422 21.1578 11.0911 21.3634 11.374C22 12.2503 22 13.5002 22 16C22 18.4998 22 19.7497 21.3634 20.626C21.1578 20.9089 20.9089 21.1578 20.626 21.3634C19.7497 22 18.4998 22 16 22C13.5002 22 12.2503 22 11.374 21.3634C11.0911 21.1578 10.8422 20.9089 10.6366 20.626C10 19.7497 10 18.4998 10 16Z",
    fill: "#72E0B2",
    stroke: "#72E0B2",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStopExportNode);
export default __webpack_public_path__ + "static/media/stop-export-node.c9252d51a80c2bf3f40e394af82900ab.svg";
export { ForwardRef as ReactComponent };